"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
var messages_es_1 = require("./messages_es");
var messages_cat_1 = require("./messages_cat");
window.adperfTracker = window.adperfTracker || {};
exports.config = {
    apiKey: APIKEY,
    backendHost: BACKENDHOST,
    backendPoint: BACKENDHOST + "/Wizards/submit&queue=true",
    context: {
        defaultCountryCode: "ES",
        folderCode: "BP_OFFER_PV-CLIENT-APPLICATION-DOCUMENTS",
        channelCode: "WEB_FV",
        templateCode: "CALCULOS_ESTIMATED_SAVINGS_SITES",
        wizardCode: "SOLIDEO_SITES",
        urlOk: "",
        domainId: DOMAINID,
        moduleRef: "300004",
        flatStructureRef: "WURTH - Kit montaje 3 placas inclinadas",
        inclinationStructureRef: "WURTH - Kit montaje 3 placas coplanares",
        defaultVoltage: "3X400",
        defaultPhases: "3",
        organizationProfile: "ESTIMATE00INDUSTRIA",
        individualProfile: "ESTIMATE00LBT24H_FD24H",
        defaultAnnualPowerPriceIncrease: 0.2,
        defaultAnnualPerformanceLoss: 0.4,
        defaultAnnualPowerConsumptionIncrease: 0,
        financingType: "none",
        defaultTariff: "2.0TD",
        individualTariff: "2.0TD",
        organizationTariff: "3.0TD",
        defaultContractedPower: 4.7,
        individualContractedPower: 4.7,
        organizationContractedPower: 30,
        individualMaxConsume: 400,
        organizationMaxConsume: 5000,
        individualDefaultConsume: 75,
        organizationDefaultConsume: 800,
        defaultModulesTilt: 20,
        defaultModulesAzimuth: 0,
        regionAutocomplete: "es",
        solutionCodeParticular: "OFERTAS_FV",
        solutionCodeOrganization: "FV_INDUSTRIAL",
        solutionCodeCommunity: "FV_COMUNIDAD_DE_VECINOS",
    },
    formMessages: {
        es: messages_es_1.messages_es,
        cat: messages_cat_1.messages_cat,
    },
    postalCodesFacilites: [
        {
            postalCode: "08610",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08695",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08600",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08619",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08617",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08680",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08604",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08696",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08618",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08698",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08614",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08698",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08680",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08695",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25716",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08694",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08605",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08612",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08698",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08611",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08696",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08606",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08697",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08607",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08694",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08517",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08699",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08613",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08673",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25283",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08611",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "08693",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17538",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25720",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17539",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17538",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17538",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17539",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17528",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17539",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25726",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17527",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17539",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25724",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25725",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25721",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25727",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17520",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17529",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25721",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17538",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17537",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25715",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25717",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25718",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25722",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25289",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25792",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25794",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25722",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25723",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25793",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25794",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25794",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25794",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25717",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25711",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25712",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25714",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25795",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25790",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25794",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25790",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25722",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25723",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25713",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25714",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25795",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25796",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25797",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25700",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25710",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25700",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25719",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25788",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25798",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25799",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "25717",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17530",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17530",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17534",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17866",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17862",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17531",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17869",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17512",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17513",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17514",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17532",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17868",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17861",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17534",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17535",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17536",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17534",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17533",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17534",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17500",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17510",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17863",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17860",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17864",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17865",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17869",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17536",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17862",
            facility: "Catalunya Nord",
        },
        {
            postalCode: "17869",
            facility: "Catalunya Nord",
        },
    ],
    facilities: [
        {
            province: "Albacete",
            facility: "Alicante",
        },
        {
            province: "Alicante/Alacant",
            facility: "Alicante",
        },
        {
            province: "Almería",
            facility: "Málaga",
        },
        {
            province: "Araba/Álava",
            facility: "Bilbao",
        },
        {
            province: "Asturias",
            facility: "Galicia",
        },
        {
            province: "Ávila",
            facility: "Madrid",
        },
        {
            province: "Badajoz",
            facility: "Madrid",
        },
        {
            province: "Illes Balears",
            facility: "Barcelona",
        },
        {
            province: "Balears, Illes",
            facility: "Barcelona",
        },
        {
            province: "Barcelona",
            facility: "Barcelona",
        },
        {
            province: "Bizkaia",
            facility: "Bilbao",
        },
        {
            province: "Burgos",
            facility: "Bilbao",
        },
        {
            province: "Cáceres",
            facility: "Madrid",
        },
        {
            province: "Cádiz",
            facility: "Málaga",
        },
        {
            province: "Cantabria",
            facility: "Bilbao",
        },
        {
            province: "Castellón/Castelló",
            facility: "Alicante",
        },
        {
            province: "Ciudad Real",
            facility: "Madrid",
        },
        {
            province: "Córdoba",
            facility: "Málaga",
        },
        {
            province: "A Coruña",
            facility: "Galicia",
        },
        {
            province: "Cuenca",
            facility: "Madrid",
        },
        {
            province: "Gipuzkoa",
            facility: "Bilbao",
        },
        {
            province: "Girona",
            facility: "Barcelona",
        },
        {
            province: "Granada",
            facility: "Málaga",
        },
        {
            province: "Guadalajara",
            facility: "Madrid",
        },
        {
            province: "Huelva",
            facility: "Málaga",
        },
        {
            province: "Huesca",
            facility: "Barcelona",
        },
        {
            province: "Jaén",
            facility: "Málaga",
        },
        {
            province: "León",
            facility: "Galicia",
        },
        {
            province: "Lleida",
            facility: "Barcelona",
        },
        {
            province: "Lugo",
            facility: "Galicia",
        },
        {
            province: "Madrid",
            facility: "Madrid",
        },
        {
            province: "Málaga",
            facility: "Málaga",
        },
        {
            province: "Murcia",
            facility: "Alicante",
        },
        {
            province: "Navarra",
            facility: "Bilbao",
        },
        {
            province: "Ourense",
            facility: "Galicia",
        },
        {
            province: "Palencia",
            facility: "Madrid",
        },
        {
            province: "Las Palmas",
            facility: "Barcelona",
        },
        {
            province: "Palmas, Las",
            facility: "Barcelona",
        },
        {
            province: "Pontevedra",
            facility: "Galicia",
        },
        {
            province: "La Rioja",
            facility: "Bilbao",
        },
        {
            province: "Rioja, La",
            facility: "Bilbao",
        },
        {
            province: "Salamanca",
            facility: "Madrid",
        },
        {
            province: "Santa Cruz de Tenerife",
            facility: "Barcelona",
        },
        {
            province: "Segovia",
            facility: "Madrid",
        },
        {
            province: "Sevilla",
            facility: "Málaga",
        },
        {
            province: "Soria",
            facility: "Madrid",
        },
        {
            province: "Tarragona",
            facility: "Barcelona",
        },
        {
            province: "Teruel",
            facility: "Barcelona",
        },
        {
            province: "Toledo",
            facility: "Madrid",
        },
        {
            province: "Valencia/València",
            facility: "Alicante",
        },
        {
            province: "Valladolid",
            facility: "Madrid",
        },
        {
            province: "Zamora",
            facility: "Madrid",
        },
        {
            province: "Zaragoza",
            facility: "Barcelona",
        },
        {
            province: "Ceuta",
            facility: "Madrid",
        },
        {
            province: "Melilla",
            facility: "Madrid",
        },
    ],
    provinces: [
        "Araba/Álava",
        "Albacete",
        "Alicante/Alacant",
        "Almería",
        "Ávila",
        "Badajoz",
        "Balears, Illes",
        "Barcelona",
        "Burgos",
        "Cáceres",
        "Cádiz",
        "Castellón/Castelló",
        "Ciudad Real",
        "Córdoba",
        "Coruña, La",
        "Cuenca",
        "Girona",
        "Granada",
        "Guadalajara",
        "Gipuzkoa",
        "Huelva",
        "Huesca",
        "Jaén",
        "León",
        "Lleida",
        "Rioja, La",
        "Lugo",
        "Madrid",
        "Málaga",
        "Murcia",
        "Navarra",
        "Ourense",
        "Asturias",
        "Palencia",
        "Palmas, Las",
        "Pontevedra",
        "Salamanca",
        "Santa Cruz de Tenerife",
        "Cantabria",
        "Segovia",
        "Sevilla",
        "Soria",
        "Tarragona",
        "Teruel",
        "Toledo",
        "Valencia/València",
        "Valladolid",
        "Bizkaia",
        "Zamora",
        "Zaragoza",
        "Ceuta",
        "Melilla",
    ],
    redirect: false,
    showCalculations: true,
    showInclination: true,
    showLanguageSelector: true,
    showOrientation: true,
    showRecommender: true,
    showModules: true,
};
